var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":"https://res.cloudinary.com/revcascade/image/upload/f_auto,w_400/static/logo.png","width":"200"}})}
var staticRenderFns = []

export { render, staticRenderFns }